import { render, staticRenderFns } from "./BanReason.vue?vue&type=template&id=ad744c72&"
import script from "./BanReason.vue?vue&type=script&lang=js&"
export * from "./BanReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports